import type { ComponentProps } from 'react';
import { Tabs as Base } from '@base-ui/react/tabs';
import { cn } from './cn';
import { focusRing } from './focus';

function List({ label, className, ...rest }: ComponentProps<typeof Base.List> & { label?: string }) {
  return <Base.List aria-label={label} className={cn('inline-flex gap-1 rounded-full bg-surface-2 p-1', className as string)} {...rest} />;
}

function Tab({ className, ...rest }: ComponentProps<typeof Base.Tab>) {
  return (
    <Base.Tab
      className={cn(
        'h-8 rounded-full px-3.5 font-sans text-sm font-medium text-fg-muted transition-colors duration-(--duration-fast) hover:text-fg data-[active]:bg-chrome data-[active]:text-fg data-[active]:shadow-sm pointer-coarse:min-h-11',
        focusRing,
        className as string,
      )}
      {...rest}
    />
  );
}

function Panel({ className, ...rest }: ComponentProps<typeof Base.Panel>) {
  return <Base.Panel className={cn('rounded-sm pt-3 outline-none', focusRing, className as string)} {...rest} />;
}

export const Tabs = { Root: Base.Root, List, Tab, Panel };
